import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import FailedAutoAwardsCard from './components/FailedAutoAwardsIndex.jsx';

const FailedAutoAwards = () => {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Failed Auto Awards</h3>
          <h3 className="page-subhead subhead"><Link className="" to="/">Home</Link> / Failed Auto Awards</h3>
        </Col>
      </Row>
      <Row>
        <FailedAutoAwardsCard />
      </Row>
    </Container>
)}

export default FailedAutoAwards;
